import { RULES } from "../rule/types";
import { Auth } from "./types";

export function hasRule(auth: Auth, rule: RULES) {
  return auth.rules.findIndex((r) => r.name === rule) !== -1;
}
